var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _path2, _path3, _path4, _path5, _path6, _circle9, _circle10, _circle11, _circle12, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5117,
    cy: 24,
    r: 16,
    fill: "#C0E5E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.51172,
    cy: 29,
    r: 2,
    fill: "#F1BC19"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0117,
    cy: 24.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5117,
    cy: 39,
    r: 1,
    fill: "#099B9B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5117,
    cy: 34,
    r: 1,
    fill: "#F1BC19"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5117,
    cy: 7,
    r: 2,
    fill: "#F1BC19"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0117,
    cy: 5.5,
    r: 0.5,
    fill: "#F1BC19"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5117,
    cy: 11,
    r: 1,
    fill: "#099B9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5099 21.7812V28.5636H26.1188H15.1626V26.9985V24.9116V23.3464H27.1623V21.7812V18.6509H30.2926H31.8578L33.423 21.7812H35.5099Z",
    fill: "#FBCD59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5099 28.5636V21.7812H33.423L31.8578 18.6509H30.2926M35.5099 28.5636H26.1188M35.5099 28.5636L33.423 24.9116H27.1623L26.1188 26.9985M27.1623 24.3898V23.3464M27.1623 23.3464H15.1626V24.9116V26.9985M27.1623 23.3464V21.7812M15.1626 26.9985V28.5636H26.1188M15.1626 26.9985H21.4233M22.4667 26.9985H26.1188M26.1188 26.9985V28.5636M27.1623 21.7812V18.6509H30.2926M27.1623 21.7812H28.7274M29.2492 21.7812H30.2926M31.8578 21.7812H30.2926M30.2926 18.6509V21.7812",
    stroke: "#523836",
    strokeWidth: 0.521725
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4238 22.8262H35.5107V23.8696H33.4238V22.8262Z",
    fill: "#F37E98",
    stroke: "#523836",
    strokeWidth: 0.521725
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5548 18.6521H11.5117L13.0769 24.391L24.0331 25.9562L26.6417 16.5652H30.8155V15H25.5983L24.5548 18.6521Z",
    fill: "#E0A825"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5986 20.2172H19.8593M20.9028 20.2172H23.5114M14.1203 21.7824H15.6855M16.729 21.7824H18.2941M18.8159 21.7824H23.5114M14.6421 22.8259H22.9897M11.5117 18.6521H24.5548L25.5983 15H30.8155V16.5652H26.6417L24.0331 25.9562L13.0769 24.391L11.5117 18.6521Z",
    stroke: "#523836",
    strokeWidth: 0.521725
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3806 21.2588H30.8154V19.1719H31.3372L32.3806 21.2588Z",
    fill: "#78CDD4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7314,
    cy: 28.5674,
    r: 2.86949,
    fill: "#836F61",
    stroke: "#472B29",
    strokeWidth: 0.521725
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2964,
    cy: 28.5674,
    r: 2.86949,
    fill: "#836F61",
    stroke: "#472B29",
    strokeWidth: 0.521725
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7305,
    cy: 28.5664,
    r: 1.04345,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.2974,
    cy: 28.5664,
    r: 1.04345,
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5557 31.6948H14.6426M15.686 31.6948H20.3815M21.9467 31.6948H34.9898",
    stroke: "#472B29",
    strokeWidth: 0.521725
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco5);
export default __webpack_public_path__ + "static/media/ico5.b625c23be98b13a40c64d6ca152f2770.svg";
export { ForwardRef as ReactComponent };